import { get, post, put, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchBrandsList = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/brands', { pagination: false }).then(response => {
    dispatch({
      type: types.FETCH_BRANDSLIST,
      payload: {
        brandsList: response['hydra:member'],
      },
    });
    return response['hydra:member'];
  });

export const fetchBrands = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/brands').then(response => {
    dispatch({
      type: types.FETCH_BRANDS,
      payload: {
        brands: response['hydra:member'],
      },
    });
    return response['hydra:member'];
  });

export const fetchBrand = (id, params) => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/brands/${id}`, params).then(response => {
    dispatch({
      type: types.FETCH_BRAND,
      payload: response,
    });
    return response;
  });

export const createBrand = data => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  post('/brands', data).then(response => {
    dispatch({
      type: types.FETCH_BRAND,
      payload: response,
    });

    return response;
  });

export const updateBrand = (selectedBrand, data) => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  put(`/brands/${selectedBrand}`, data).then(response => {
    dispatch({
      type: types.FETCH_BRAND,
      payload: response,
    });

    return response;
  });

export const fetchBrandConfigModules =
  ({ brandId, qs }) =>
  dispatch =>
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`/brands/${brandId}/modules`, { ...qs }).then(response => {
      dispatch({
        type: `${types.FETCH_BRAND_CONFIG_MODULE}_SUCCESS`,
      });

      return response;
    });

export const fetchBrandConfigModulesPack = (brandId, moduleNames) => {
  const qs = moduleNames.map(m => `module[]=${m}`).join('&');
  return dispatch =>
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`/brands/${brandId}/modules?${qs}`).then(response => {
      dispatch({
        type: `${types.FETCH_BRAND_CONFIG_MODULE}S_SUCCESS`,
        payload: response.configuration ?? {},
      });

      return response;
    });
};

export const updateBrandConfigModule = (brandId, moduleName, configuration) =>
  put(`/brands/${brandId}/module`, {
    module: moduleName,
    configuration,
  });

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
export const updateBrandConfigModulesPack = (brandId, modules) => dispatch =>
  put(`/brands/${brandId}/modules`, {
    configuration: modules,
  });

export const removeBrand = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/brands/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_BRAND,
      payload: {
        brandId: id,
      },
    });
  });

export const fetchPaymentTypes = selectedBrandId => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`brands/${selectedBrandId}/modules?module[]=ItemPaymentTypes`).then(
    response => {
      dispatch({
        type: `${types.FETCH_PAYMET_TYPES}_SUCCESS`,
        payload: response.configuration.ItemPaymentTypes,
      });
    }
  );

export const selectDefaultPaymentType = (order, paymentType) => dispatch =>
  dispatch({
    type: 'SET_DEFAULT_PAYMENT_TYPE',
    payload: { order, paymentType },
  });

export const setEnabledPaymentTypes = (order, paymentTypes) => dispatch =>
  dispatch({
    type: 'SET_ENABLED_PAYMENT_TYPES',
    payload: { order, paymentTypes },
  });

export const fetchCountryInformations = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/country-informations').then(response => {
    dispatch({
      type: `${types.FETCH_COUNTRY_INFORMATIONS}_SUCCESS`,
      payload: response,
    });
  });

export const setMultinational = multinational => dispatch => {
  dispatch({
    type: 'SET_MULTINATIONAL',
    payload: multinational,
  });
};
